import { createFileRoute, redirect } from '@tanstack/react-router'

/** Legacy order URL, one hop to the same order under State filings. */
export const Route = createFileRoute('/_shell/state-tax/$id')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/state-filings/orders/$id', params: { id: params.id }, replace: true })
  },
})
